module.exports = __webpack_public_path__ + "static/media/shuttlecock.16b27a35.svg";